// extracted by mini-css-extract-plugin
export default {"main-header":"Header_main-header__WI7q4","main-nav":"Header_main-nav__ZZuha"};